//palete
//#42778C
//#B4CED9
//#D9B855
//#D9CBA0
//#F2F2F2


export default{
    primary:'#B4CED9',
    secondary:{
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#000',
    },
    blue:{
        50:'#E3F2FD',
        100:'#BBDEFB',
        200:'#90CAF9',
        300:'#64B5F6',
        400:'#42A5F5',
        500:'#2196F3',
        600:'#1E88E5',
        700:'#1976D2',
        800:'#1565C0',
        900:'#0D47A1',
        light: '#64B5F6',
        main: '#007afb',
        dark: '#0D47A1',
        contrastText: '#000',
        contrastTextLight: '#FFF',
    },
    purple:{
        500:'#9C27B0',
        light: '#CE93D8',
        main: '#9C27B0',
        dark: '#6A1B9A',
        contrastText: '#000',
        contrastTextLight: '#FFF',
    },
    green:{
        50:'#E8F5E9',
        100:'#C8E6C9',
        200:'#A5D6A7',
        300:'#81C784',
        400:'#66BB6A',
        500:'#4CAF50',
        600:'#43A047',
        700:'#388E3C',
        800:'#2E7D32',
        900:'#1B5E20',
        light: '#A5D6A7',
        main: '#4CAF50',
        dark: '#2E7D32',
        contrastText: '#000',
        contrastTextLight: '#FFF',
    },
    yellow:{
        50:'#FFFDE7',
        100:'#FFF9C4',
        200:'#FFF59D',
        300:'#FFF176',
        400:'#FFEE58',
        500:'#FFEB3B',
        600:'#FDD835',
        700:'#FBC02D',
        800:'#F9A825',
        900:'#F57F17',
        light: '#FFF59D',
        main: '#FFEB3B',
        dark: '#F9A825',
        contrastText: '#000',
        contrastTextLight: '#666',
    },
    orange:{
        50:'#FFF3E0',
        100:'#FFE0B2',
        200:'#FFCC80',
        300:'#FFB74D',
        400:'#FFA726',
        500:'#FF9800',
        600:'#FB8C00',
        700:'#F57C00',
        800:'#EF6C00',
        900:'#E65100',
        light: '#FFCC80',
        main: '#FF9800',
        dark: '#EF6C00',
        contrastText: '#000',
        contrastTextLight: '#FFF',
    },
    darker:'#111',
    dark:'#333',
    regular:'#666',
    gray:'#808080',
    light:'#c0c0c0',
    lighter:"#eee",
    white:'#FFF',
    primary_dark:'#42778C',
    primary_darker:'#0e2339',
    danger:'#B22222',
    success:'#228B22',
    blue50:'#E3F2FD',
    blue100:'#BBDEFB',
    blue200:'#90CAF9',
    blue300:'#64B5F6',
    blue400:'#42A5F5',
    blue500:'#007afb',
    blue600:'#1E88E5',
    blue700:'#2257de',
    blue800:'#1565C0',
    blue900:'#0D47A1',
    green500:'#00a152',
    yellow500:'#FF9800',
    red500:'#D50000',
    main:'#e9e9e9'
}


// WEBPACK FOOTER //
// ./src/styles/colors.js